import { AssetfiAssetType } from '@/types/asset-type';

export default function InfoSvg({ width, height }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 current current" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.33333 6.39974H7V10.0664M7 10.0664H8M7 10.0664H6M13 7.06641C13 10.3801 10.3137 13.0664 7 13.0664C3.68629 13.0664 1 10.3801 1 7.06641C1 3.7527 3.68629 1.06641 7 1.06641C10.3137 1.06641 13 3.7527 13 7.06641ZM6.66667 4.39974V4.06641H7V4.39974H6.66667Z"
        stroke="#FF6854"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
